import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	lightPurple: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightBlue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightGreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightTeal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightYellow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightRed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lightGray: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	purple: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	green: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yellow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	red: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gray: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	lightPurple: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple',
		defaultMessage: 'Subtle purple',
		description: 'Aria-label for subtle purple color button',
	},
	lightBlue: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue',
		defaultMessage: 'Subtle blue',
		description: 'Aria-label for subtle blue color button',
	},
	lightGreen: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green',
		defaultMessage: 'Subtle green',
		description: 'Aria-label for subtle green color button',
	},
	lightTeal: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal',
		defaultMessage: 'Subtle teal',
		description: 'Aria-label for subtle teal color button',
	},
	lightYellow: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow',
		defaultMessage: 'Subtle yellow',
		description: 'Aria-label for subtle yellow color button',
	},
	lightRed: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red',
		defaultMessage: 'Subtle red',
		description: 'Aria-label for subtle red color button',
	},
	lightGray: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray',
		defaultMessage: 'Subtle gray',
		description: 'Aria-label for subtle gray color button',
	},
	purple: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.purple',
		defaultMessage: 'Bold purple',
		description: 'Aria-label for purple color button',
	},
	blue: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.blue',
		defaultMessage: 'Bold blue',
		description: 'Aria-label for blue color button',
	},
	green: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.green',
		defaultMessage: 'Bold green',
		description: 'Aria-label for green color button',
	},
	teal: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.teal',
		defaultMessage: 'Bold teal',
		description: 'Aria-label for teal color button',
	},
	yellow: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow',
		defaultMessage: 'Bold yellow',
		description: 'Aria-label for yellow color button',
	},
	red: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.red',
		defaultMessage: 'Bold red',
		description: 'Aria-label for red color button',
	},
	gray: {
		id: 'business-conditional-formatting-sidebar.common.utils.formatting-colors.gray',
		defaultMessage: 'Bold gray',
		description: 'Aria-label for gray color button',
	},
});
export default messages;
